import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import documentReducer from './Document/documentReducer';
import clientReducer from './Client/clientReducer';
import UserReducer from './User/userReducer';
import PaddleReducer from './Paddle/paddleReducer';
import RevealrReducer from './Revealr/revealrReducer';
import SearchReducer from './Search/searchReducer';

export const rootReducer = combineReducers({
  document: documentReducer,
  client: clientReducer,
  user: UserReducer,
  paddle: PaddleReducer,
  queries: RevealrReducer,
  search: SearchReducer,
});

/* Create Store */
const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

export default store;
